// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__2yDlO","button":"Counter_button__D-Nsf","disabled":"Counter_disabled__beheo","number":"Counter_number__4tl9t"};